import { render } from "./LbrxKioskPopup.vue?vue&type=template&id=5c2cd33a&scoped=true"
import script from "./LbrxKioskPopup.vue?vue&type=script&lang=js"
export * from "./LbrxKioskPopup.vue?vue&type=script&lang=js"

import "./LbrxKioskPopup.vue?vue&type=style&index=0&id=5c2cd33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2cd33a"]])

export default __exports__